import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import GroceryCase from './pages/GroceryCase';
import FoodDeliveryCase from './pages/FoodDeliveryCase';
import HealthcareCase from './pages/HealthcareCase';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/grocery" element={<GroceryCase />} />
        <Route path="/food-delivery" element={<FoodDeliveryCase />} />
        <Route path="/healthcare" element={<HealthcareCase />} />
      </Routes>
    </Router>
  );
}

export default App;